type DataTestidType = Record<'data-testid', any>;

type UseDataTestIdReturnType = {
  getTestId(id: string): DataTestidType;
};

export function useDataTestId(): UseDataTestIdReturnType {
  const { REACT_APP_NODE_ENV } = process.env;
  const isProduction = REACT_APP_NODE_ENV === 'production';

  return {
    getTestId(id: string) {
      if (!isProduction) {
        return {
          'data-testid': id,
        };
      }

      return {} as DataTestidType;
    },
  };
}
